module.exports = __webpack_public_path__ + "static/media/investpic3.f27beace.png";